import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const customsSimulatorContract = c.router({
  enableBatchCustomsSimulator: {
    method: 'PATCH',
    path: '/customs-simulator/:batchId/enable',
    pathParams: z.object({
      batchId: z.string(),
    }),
    body: c.noBody(),
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
  getBatchDeclarationGroups: {
    method: 'GET',
    path: '/customs-simulator/:batchId/declaration-groups',
    pathParams: z.object({
      batchId: z.string(),
    }),
    responses: {
      200: z.object({
        groupsData: z.array(
          z.object({
            lrn: z.string(),
            sequences: z.array(z.string()),
            currentStatus: z.string().optional(),
          }),
        ),
      }),
    },
  },
  getBatchCustomsSimulatorStatuses: {
    method: 'GET',
    path: '/customs-simulator/:batchId/statuses',
    pathParams: z.object({
      batchId: z.string(),
    }),
    responses: {
      200: z.object({
        statuses: z.array(z.string()),
      }),
    },
  },
  setBatchImmediateResponse: {
    method: 'POST',
    path: '/customs-simulator/:batchId/set-immediate-response',
    pathParams: z.object({
      batchId: z.string(),
    }),
    body: z.object({
      responseType: z.enum(['acknowledge', 'rejected']),
    }),
    responses: {
      200: z.object({
        message: z.string(),
        results: z.array(
          z.object({
            lrn: z.string(),
            response: z.enum(['ACKNOWLEDGED', 'REJECTED']),
            correlationId: z.string(),
            message: z.string(),
          }),
        ),
      }),
    },
  },
  enableTsdCustomsSimulator: {
    method: 'PATCH',
    path: '/customs-simulator/tsd/:tsdId/enable',
    pathParams: z.object({
      tsdId: z.string(),
    }),
    body: c.noBody(),
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
  setTsdImmediateResponse: {
    method: 'POST',
    path: '/customs-simulator/tsd/:tsdId/set-immediate-response',
    pathParams: z.object({
      tsdId: z.string(),
    }),
    body: z.object({
      responseType: z.enum(['acknowledge', 'rejected']),
    }),
    responses: {
      200: z.object({
        message: z.string(),
        response: z.enum(['ACKNOWLEDGED', 'REJECTED']),
        correlationId: z.string(),
      }),
    },
  },
  setNotificationsStatus: {
    method: 'POST',
    path: '/customs-simulator/set-notifications',
    body: z.object({
      lrns: z
        .array(
          z.object({
            lrn: z.string(),
            status: z.string(),
            useCallback: z.boolean().optional(),
            callbackDelay: z.number().optional(),
          }),
        )
        .min(1),
    }),
    responses: { 200: z.boolean() },
  },
});
